import React from "react";

import { MetricQuery } from "~/models/metric-query";
import { useScoped } from "~/tools/impulse";

import type { MonitorCheckStatusMetric } from "../../../../common/openapi";
import { Widget, WidgetBody, WidgetHeader } from "../../../../components/_widget";
import { ThumbnailTimeSeriesChart } from "../../../../components/react/metrics/ThumbnailTimeSeriesChart";

import { useMonitorStatusDrawerContext } from "./MonitorStatusDrawer/use-monitor-status-drawer-context";
import { MONITOR_STATUS_DRAWER_QUERY_NAMESPACE } from "./_query-namespace";

interface MonitorStatusDrawerMetricsProps {
	metrics: ReadonlyArray<MonitorCheckStatusMetric>;
}

export const MonitorStatusDrawerMetrics: React.FC<MonitorStatusDrawerMetricsProps> = ({ metrics }) => {
	const { timestamp, timeRange } = useMonitorStatusDrawerContext();
	const timestampValue = useScoped(timestamp);

	return (
		<Widget card>
			<WidgetHeader
				help="These metrics are automatically provided by the monitor as evidence for the triggered state. The metrics use the same time window as the telemetry interval set on the timeline."
				size="lg"
				title="Monitor triggering evidence"
			/>
			<WidgetBody className="flex gap-6">
				{metrics.map(({ name, unit, queries }) => (
					<ThumbnailTimeSeriesChart
						batch={name}
						className="flex-1"
						key={name}
						markerTimestamp={timestampValue}
						metricQueries={queries.map(MetricQuery)}
						namespace={MONITOR_STATUS_DRAWER_QUERY_NAMESPACE}
						timeRange={timeRange}
						title={name}
						unit={unit}
					/>
				))}
			</WidgetBody>
		</Widget>
	);
};
